/** @jsx jsx */
import { jsx, ThemeProvider, ThemeStateProvider, ColorMode } from 'theme-ui';
import React from 'react';
import theme from './index';
import components from './components';

var hasColorModes = function hasColorModes(t) {
  return t.colors && t.colors.modes && Object.keys(t.colors.modes).length;
};

export var wrapRootElement = function wrapRootElement(_ref) {
  var element = _ref.element;
  return jsx(ThemeStateProvider, {
    theme: theme
  }, jsx(ThemeProvider, {
    components: components
  }, hasColorModes(theme) && jsx(ColorMode, {
    key: 'theme-ui-color-mode'
  }), React.cloneElement(element, {
    key: 'element'
  })));
};